import { useMemo } from 'react';
import useProductSearchParams from '@/app/[locale]/new/(products)/[productType]/[...slug]/components/hooks/useProductSearchParams';
export default function useCheckoutParams() {
    const { productSearchParams } = useProductSearchParams();
    const { participants, inclusions, } = productSearchParams;
    const travelersCount = useMemo(() => {
        const count = parseInt(participants, 10);
        return isNaN(count) || count < 1 ? 1 : count;
    }, [participants]);
    return {
        travelersCount,
        inclusions: inclusions,
    };
}
